export default __webpack_public_path__ + "static/media/Img014.0350a16e.jpg";